import { findTemplateByName, getTemplateParts } from '../utils';
import TemplateRegistry from '../../templates';
import { Example } from '../modules/components/Demo';
import { DashboardJson } from '../modules/models';

export const getExamplesInfo = (templates: string[]): Example[] => {
  return (
    templates?.map(templateName => {
      const json = findTemplateByName(TemplateRegistry, templateName);
      const { name, tags, title } = getTemplateParts(json as DashboardJson);
      return {
        name,
        tags,
        title,
      } as Example;
    }) ?? []
  );
};
